import * as yup from "yup";

import { FORM_FIELDS } from "@constants/form";

export const TERMINATION = FORM_FIELDS.TERMINATION;
export const BASIC_INFO = TERMINATION.BASIC_INFO;
export const SUPPORTING_DOCUMENT = TERMINATION.SUPPORTING_DOCUMENT;
export const MODAL = TERMINATION.MODAL;

export const terminationFormValidation = yup.object().shape({
  [BASIC_INFO.TERMINATE_DATE]: yup
    .string()
    .required("Termination date is required"),
});

export type TerminationFormDataType = yup.InferType<
  typeof terminationFormValidation
>;
